'use strict';

(function ($) {
   $(document).ready(function () {
       // Add your API key below to test this code
       // Get all years and update vehicle_year select box
       $.get(
           'https://carmakemodeldb.com/api/v1/car-lists/get/years' +
               '?api_token=' +
               process.env.CAR_API,
           function (data) {
               const year = $('#form-field-year');
               year.empty();
               year.append("<option value=''>Select Year</option>");
               data.reverse();
               $.each(data, function (index, element) {
                   year.append(
                       "<option value='" +
                           element.year +
                           "'>" +
                           element.year +
                           '</option>'
                   );
               });
           }
       );

       // Get makes based on vehicle_year selected
       // Updated vehicleInfo div after year is selected
       $('#form-field-year').change(function () {
           $.get(
               'https://carmakemodeldb.com/api/v1/car-lists/get/makes' +
                   '/' +
                   $(this).val() +
                   '?api_token=' +
                   process.env.CAR_API,
               function (data) {
                   const make = $('#form-field-make');
                   make.empty();
                   make.append("<option value=''>Select Make</option>");
                   $.each(data, function (index, element) {
                       make.append(
                           "<option value='" +
                               element.make +
                               "'>" +
                               element.make +
                               '</option>'
                       );
                   });
               }
           );
           $('#vehicleInfo').html(
               'Year: <strong>' + $('#form-field-year').val() + '</strong>'
           );
           $('#form-field-vin').val('');
       });

       // Get models based on vehicle_year and vehicle_make selection
       // Updated vehicleInfo div after make is selected
       $('#form-field-make').change(function () {
           const vehYear = $('#form-field-year').val();
           $.get(
               'https://carmakemodeldb.com/api/v1/car-lists/get/models' +
                   '/' +
                   vehYear +
                   '/' +
                   $(this).val() +
                   '?api_token=' +
                   process.env.CAR_API,
               function (data) {
                   const model = $('#form-field-model');
                   model.empty();
                   model.append("<option value=''>Select Model</option>");
                   $.each(data, function (index, element) {
                       model.append(
                           "<option value='" +
                               element.model +
                               "'>" +
                               element.model +
                               '</option>'
                       );
                   });
               }
           );
           $('#vehicleInfo').html(
               'Year: <strong>' +
                   vehYear +
                   '</strong><br>Make: <strong>' +
                   $('#form-field-make').val() +
                   '</strong>'
           );
           $('#form-field-vin').val('');
       });

       // Get trims based on vehicle_year, vehicle_make, and vehicle_model selected
       // Updated vehicleInfo div after model is selected
       $('#form-field-model').change(function () {
           const vehYear = $('#form-field-year').val();
           const vehMake = $('#form-field-make').val();

           $.get(
               'https://carmakemodeldb.com/api/v1/car-lists/get/trims' +
                   '/' +
                   vehYear +
                   '/' +
                   vehMake +
                   '/' +
                   $(this).val() +
                   '?api_token=' +
                   process.env.CAR_API,
               function (data) {
                   const trim = $('#form-field-trim');
                   trim.empty();
                   trim.append("<option value=''>Select Trim</option>");
                   $.each(data, function (index, element) {
                       trim.append(
                           "<option value='" +
                               element.trim +
                               "'>" +
                               element.trim +
                               '</option>'
                       );
                   });
               }
           );
           $('#vehicleInfo').html(
               'Year: <strong>' +
                   vehYear +
                   '</strong><br>Make: <strong>' +
                   vehMake +
                   '</strong><br>Model: <strong>' +
                   $(this).val() +
                   '</strong>'
           );
           $('#form-field-vin').val('');
       });

       // Updated vehicleInfo div after trim is selected
       $('#form-field-trim').change(function () {
           $('#vehicleInfo').html(
               'Year: <strong>' +
                   $('#form-field-year').val() +
                   '</strong><br>Make: <strong>' +
                   $('#form-field-make').val() +
                   '</strong><br>Model: <strong>' +
                   $('#form-field-model').val() +
                   '</strong><br>Trim: <strong>' +
                   $('#form-field-trim').val() +
                   '</strong>'
           );
       });
       $('#form-field-vin').val('');

       // Show loading gif after item is selected
       $(document)
           .ajaxStart(function () {
               $('#loading').show();
           })
           .ajaxStop(function () {
               $('#loading').hide();
           });
   });
   $(document).ready(function () {
       const baseurl = 'https://vpic.nhtsa.dot.gov/api/vehicles/';
       $('#form-field-vin').bind('keyup', function () {
           const vinid = $('#form-field-vin').val();
           //console.log(vinid);
           if (vinid !== '') {
               const posturl =
                   baseurl + 'DecodeVinValues/' + vinid + '?format=json';
               $.ajax({
                   url: posturl,
                   type: 'GET',
                   dataType: 'json',
                   data: vinid,
                   success(result) {
                       //console.log(result);
                       const vinData = result.Results;
                       //console.log(vinData[0].Make);
                       $('#vehicleInfo').html(
                           'Year: <strong>' +
                               vinData[0].ModelYear +
                               '</strong><br>Make: <strong>' +
                               vinData[0].Make +
                               '</strong><br>Model: <strong>' +
                               vinData[0].Model +
                               '</strong><hr><p style="color:green">' +
                               vinData[0].ErrorText +
                               '</p>'
                       );
                       $('#form-field-year').val('');
                       $('#form-field-make').val('');
                       $('#form-field-model').val('');
                       $('#form-field-trim').val('');
                   },
                   //error(xhr, ajaxOptions, thrownError) {
                       //console.log(xhr.status);
                       //console.log(thrownError);
                   //},
               }); //end AJAX VinCheck
           } else {
               $('#form-field-vin').empty();
           } //end if
       });
   });
})(jQuery);
